export function getRelevantProjectHandle(commercialProjectName: string | null, name: string | null): string | null {
    if (commercialProjectName === null || commercialProjectName === '') {
        return name;
    } else {
        return commercialProjectName;
    }
}
